module.exports = "<things-group-list></things-group-list>"


//////////////////
// WEBPACK FOOTER
// D:/dclean-web-latest/task/cot-web/src/app/pages/things/thingsGroup.component.html
// module id = ../../../../../src/app/pages/things/thingsGroup.component.html
// module chunks = main